import React, { Component } from "react";
import "../containers/MainAppContainer.css";
import { translations } from "../containers/assets/translations";
import Checkbox from "@material-ui/core/Checkbox";
import { ControlLabel } from "react-bootstrap";

export default class FetchItineraries extends Component {
	
  render() {
    var lang = this.props.lang;
    return (
      <div className="SearchOptions col-md-12 col-xs-12" style={{ height: "335px" }}>
      <div className = "d-flex col-md-6 col-sm-6 col-xs-12">
        <ControlLabel>Include inactive routes</ControlLabel>
        <Checkbox
          className="checkboxnonShow"
          checked={this.props.CItineraries}
          color="primary"
          onClick={() => {
            this.props.handleItineraries(1);
          }}
        />
        </div>
        <div className = "d-flex col-md-6 col-sm-6 col-xs-12">
        <ControlLabel>Confirm when deleting boarding passes</ControlLabel>
				<Checkbox
          className="checkboxnonShow"
					checked={this.props.DItineraries}
					color="primary"
					onClick={() => {
						this.props.handleItineraries(2);						
					}}
				/>
        </div>
        <div className="col-md-12 head">
          <div className="col-md-3">
            {translations[lang]["Company"]} / {translations[lang]["Vessel"]}
          </div>
          <div className="col-md-3">{translations[lang]["Arrival Port"]}</div>
          <div className="col-md-3">
            {translations[lang]["Departure"]} ({translations[lang]["Date"]} -{" "}
            {translations[lang]["Time"]})
          </div>
          <div className="col-md-3">
            {translations[lang]["Arrival"]} ({translations[lang]["Date"]} -{" "}
            {translations[lang]["Time"]})
          </div>
        </div>
        <div className="scrollbar style-1" style={{ border: "1px solid #cccccc"}}>
          <div>
            {this.props.itineraries.map((post, index) => {
              let className =
                this.props.selectedItineraryIndex === index
                  ? "col-md-12 col-xs-12 selectedItinerary"
                  : "col-md-12 col-xs-12 resultsR";
              return (
                <div
                  className={className}
                  id={
                    post.ItineraryID +
                    "@" +
                    post.SailID +
                    "@" +
                    post.CompanyCode +
                    "@" +
                    post.AvailablePassengers +
                    "@" +
                    post.AvailableVehicles +
                    "@" +
                    post.OccupiedPassengers +
                    "@" +
                    post.OccupiedVehicles +
                    "@" +
                    post.CheckedInPassengers +
                    "@" +
                    post.CheckedInVehicles +
                    "@" +
                    post.RemainderPassengers +
                    "@" +
                    post.RemainderVehicles +
                    "@" +
                    post.ConfirmedPassengerCounter +
                    "@" +
                    post.ConfirmedVehicleCounter +
                    "@" +
                    post.ConfirmedPassengerRemaining +
                    "@" +
                    post.ConfirmedVehicleRemaining +
                    "@" +
                    post.SailID
                  }
                  key={post.ItineraryID}
                  onClick={event => {
                    this.props.handleClick(event, index);
                  }}
                >
                  <div
                    className="col-md-3 col-sm-6 col-xs-6  resultcol"
                    id={
                      post.ItineraryID +
                      "@" +
                      post.SailID +
                      "@" +
                      post.CompanyCode +
                      "@" +
                      post.AvailablePassengers +
                      "@" +
                      post.AvailableVehicles +
                      "@" +
                      post.OccupiedPassengers +
                      "@" +
                      post.OccupiedVehicles +
                      "@" +
                      post.CheckedInPassengers +
                      "@" +
                      post.CheckedInVehicles +
                      "@" +
                      post.RemainderPassengers +
                      "@" +
                      post.RemainderVehicles +
                      "@" +
                      post.ConfirmedPassengerCounter +
                      "@" +
                      post.ConfirmedVehicleCounter +
                      "@" +
                      post.ConfirmedPassengerRemaining +
                      "@" +
                      post.ConfirmedVehicleRemaining +
                      "@" +
                      post.SailID
                    }
                  >
                    <span className="rowdescr">
                      {translations[lang]["Company"]} /{" "}
                      {translations[lang]["Vessel"]}:{" "}
                    </span>
                    {post.CompanyDescription} / {post.VesselName}
                  </div>
                  <div
                    id={
                      post.ItineraryID +
                      "@" +
                      post.SailID +
                      "@" +
                      post.CompanyCode +
                      "@" +
                      post.AvailablePassengers +
                      "@" +
                      post.AvailableVehicles +
                      "@" +
                      post.OccupiedPassengers +
                      "@" +
                      post.OccupiedVehicles +
                      "@" +
                      post.CheckedInPassengers +
                      "@" +
                      post.CheckedInVehicles +
                      "@" +
                      post.RemainderPassengers +
                      "@" +
                      post.RemainderVehicles +
                      "@" +
                      post.ConfirmedPassengerCounter +
                      "@" +
                      post.ConfirmedVehicleCounter +
                      "@" +
                      post.ConfirmedPassengerRemaining +
                      "@" +
                      post.ConfirmedVehicleRemaining +
                      "@" +
                      post.SailID
                    }
                    className="col-md-3 col-sm-6 col-xs-6  resultcol"
                  >
                    <span className="rowdescr">
                      {translations[lang]["Arrival Port"]}:{" "}
                    </span>
                    {post.ArrivalPortDescription}
                  </div>
                  <div
                    id={
                      post.ItineraryID +
                      "@" +
                      post.SailID +
                      "@" +
                      post.CompanyCode +
                      "@" +
                      post.AvailablePassengers +
                      "@" +
                      post.AvailableVehicles +
                      "@" +
                      post.OccupiedPassengers +
                      "@" +
                      post.OccupiedVehicles +
                      "@" +
                      post.CheckedInPassengers +
                      "@" +
                      post.CheckedInVehicles +
                      "@" +
                      post.RemainderPassengers +
                      "@" +
                      post.RemainderVehicles +
                      "@" +
                      post.ConfirmedPassengerCounter +
                      "@" +
                      post.ConfirmedVehicleCounter +
                      "@" +
                      post.ConfirmedPassengerRemaining +
                      "@" +
                      post.ConfirmedVehicleRemaining +
                      "@" +
                      post.SailID
                    }
                    className="col-md-3 col-sm-6 col-xs-6  resultcol"
                  >
                    <span className="rowdescr">
                      {translations[lang]["Departure"]}:{" "}
                    </span>
                    {post.DepartureDate.substr(-2)}/
                    {post.DepartureDate.substr(-4, 2)}/
                    {post.DepartureDate.substr(0, 4)} -{" "}
                    {post.DepartureTime.substr(0, 2)}:
                    {post.DepartureTime.substr(2, 2)}
                  </div>
                  <div
                    className="col-md-3 col-sm-6 col-xs-6  resultcol"
                    id={
                      post.ItineraryID +
                      "@" +
                      post.SailID +
                      "@" +
                      post.CompanyCode +
                      "@" +
                      post.AvailablePassengers +
                      "@" +
                      post.AvailableVehicles +
                      "@" +
                      post.OccupiedPassengers +
                      "@" +
                      post.OccupiedVehicles +
                      "@" +
                      post.CheckedInPassengers +
                      "@" +
                      post.CheckedInVehicles +
                      "@" +
                      post.RemainderPassengers +
                      "@" +
                      post.RemainderVehicles +
                      "@" +
                      post.ConfirmedPassengerCounter +
                      "@" +
                      post.ConfirmedVehicleCounter +
                      "@" +
                      post.ConfirmedPassengerRemaining +
                      "@" +
                      post.ConfirmedVehicleRemaining +
                      "@" +
                      post.SailID
                    }
                  >
                    <span className="rowdescr">
                      {translations[lang]["Arrival"]}:{" "}
                    </span>
                    {post.ArrivalDate.substr(-2)}/
                    {post.ArrivalDate.substr(-4, 2)}/
                    {post.ArrivalDate.substr(0, 4)} -{" "}
                    {post.ArrivalTime.substr(0, 2)}:
                    {post.ArrivalTime.substr(2, 2)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FetchItineraries.js